/* Tysk katalog for locale-closing-cash-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'clo.cash.quickComments': 'Schnellkommentare',
  'clo.cash.quickCountLabel': 'Von der Geschäftsführung gezählt',
  'clo.cash.quickCountText': 'Der Kassenbestand wurde zum 31.12.{{year}} von der Geschäftsführung physisch gezählt.',
  'clo.cash.quickSheetLabel': 'Zählprotokoll gespeichert',
  'clo.cash.quickSheetText': 'Das unterschriebene Zählprotokoll wurde geprüft und im Belegordner gespeichert.',
  'clo.cash.quickReportLabel': 'Mit Kassenbericht abgeglichen',
  'clo.cash.quickReportText': 'Die Zählung wurde mit dem Kassenbericht zum 31.12.{{year}} abgeglichen.',
  'clo.cash.openPosting': 'Freie Buchung erstellen',
  'clo.cash.postingTitle': 'Kassenbestand korrigieren',
  'clo.cash.postingDescription': 'Korrektur nach Kassenzählung {{year}}',
  'clo.cash.postingLoadError': 'Die freie Buchung konnte nicht geladen werden.',
  'clo.cash.postingSaved': 'Die Buchung wurde gebucht. Prüfe die Differenz erneut.',
});
